import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetReports } from 'domain/usecases/reports/get-reports';
import { RemoteGetAllReports } from 'data/usecases/reports/remote-get-all-reports';

export const makeRemoteGetReports = (): GetReports => {
  return new RemoteGetAllReports(makeApiUrl('/getReports'), makeAuthorizeHttpClientDecorator());
};
